module.exports = __webpack_public_path__ + "img/9788925545936.da416c0e.jpg";